var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('core-grid',{ref:"grid",attrs:{"flat":"","modal":"","onRead":_vm.onRead,"schema":_vm.schema}}),_c('SimulacaoEditGarantiaEdit',{ref:"editar",on:{"close":_vm.handleGarantia}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }